<template>
    <div class="projectInfo"
        :class="eventList.level == 'urgent' ? 'red' : eventList.level == 'hiddenDanger' ? 'yell' : ''">
        <div class="top">
            <div class="left">
                <div class="name">
                    {{ selProjectName }} <span v-show="routeName == 'PowerDistribution' || routeName == 'Photovoltaic'"> -
                        {{ selAreaName }}</span>
                    <img src="@/assets/img/change.png" alt="" @click.stop="showGroup = !showGroup"  ref="charea">
                </div>
            </div>
            <div class="right" v-if="projectId!=13">
                网关在线：<label v-if="gatewayall.length > 0"><span>{{ Ebox }}/</span>{{ gatewayall.length }}</label>
                <label v-else>--</label>
            </div>
            <div class="right" v-else>
                网关在线：<label ><span>5/</span>5</label>
            </div>
        </div>
        <div class="alarm row-center" v-if="!alarmShow">
            <div class="left row-center" @click="goAlarmUrl()">
                <img src="@/assets/img/warm.png" alt="">
                <span class="state">{{ eventList.levelText }}</span>
                <span class="name u-line-1"><i v-if="eventList.loopName">{{ eventList.loopName }}-</i>{{ eventList.eventName }}</span>
                <i class="el-icon-arrow-right"></i>
            </div>
            <span class="time">{{ eventList.startTime | dateFormat }} </span>
        </div>
        <div class="run" v-else>
            稳定运行：<span>{{ projectInfo.deploymentTime ? getDistanceSpecifiedTime(projectInfo.deploymentTime) : '--' }}</span>天
        </div>
        <div class="weather row-center" v-if="routeName != 'PowerDistribution'">
            <span>{{ WeatherInfo.text }}：{{ WeatherInfo.temp }}℃</span>
            <span>湿度：{{ WeatherInfo.humidity }}%</span>
            <span v-if="routeName == 'Photovoltaic'">辐照度：300W/㎡</span>
            <span v-else>空气质量：{{ WeatherInfo.category }}</span>
        </div>
        <div class="weather row-center" v-else>
            <span>室内温度：{{ mqttval(subLoopUrl + '/' + 'Temperature') ? mqttval(subLoopUrl + '/' +
                    'Temperature') : '--'
            }}℃</span>
            <span>室内湿度：{{ mqttval(subLoopUrl + '/' + 'Humidity') ? mqttval(subLoopUrl + '/' + 'Humidity') : '--' }}%</span>
            <span>烟感状态：{{ mqttval(smokeSubLoopUrl + '/' + 'smoke') ? mqttval(smokeSubLoopUrl + '/' + 'smoke')==0?'无烟':'有烟': '--' }}</span>
        </div>
        <div class="group" v-show="showGroup" :class="{ workselist: routeName == 'WorkBench' }" ref="area">
            <el-scrollbar style="height:100%">
                <div class="selist">
                    <div class="title">{{ projectInfo.projectName }} </div>
                    <div class="list" v-for="(elm, index1) in projectInfo.areaList" v-if="elm.areaType == 1 || elm.areaType == 2"
                        :key="index1 + '-only'" @click="checkArea(elm)"
                        :class="{ active: elm.areaId == AreaId && (routeName == 'Photovoltaic' || routeName == 'PowerDistribution') }">
                        {{ elm.areaName }}
                        <span><img src="@/assets/img/right-a.png"
                                v-if="elm.areaId == AreaId && (routeName == 'Photovoltaic' || routeName == 'PowerDistribution')"><img
                                src="@/assets/img/right.png" v-else></img></span>
                    </div>
                </div>
                <div v-for="(group, index) in projectGroup" :key="index + '-only1'" class="taglist">
                    <div class="title">{{ group.projectName }} <span @click="tagpark(group)">切换园区</span></div>
                </div>
            </el-scrollbar>
        </div>

    </div>
</template>
<script>
import { userAllgroup, EventListPage, DeviceALL, GetSensor,sensorType } from '../../api/power.js'
import { dateFormat } from '../../util/DateUtil';
import { play } from "../../api/login";
import { subscribe, connect as connectMqtt, disconnect } from '../../mqtt/index'
import {
    connect as alarmConnect
} from "../../mqtt/alarm";
export default {
    props: {

    },
    data() {
        return {
            //projectGroup:{},
            eventList: {},
            alarmShow: false,
            showGroup: false,
            gatewayall: [],
            All: [],
            subLoopUrl: "",
            smokeSubLoopUrl:""
            // selProjectName:"",
            // selAreaName:""
        }
    },
    components: {

    },
    filters: {
        dateFormat: function (value) {
            if (!value) {
                return '--';
            }
            return dateFormat('YYYY年mm月dd日 HH:MM', new Date(value));
        }
    },
    computed: {
        selAreaName() {
            return this.$store.getters.selAreaInfo.areaName;
        },
        selProjectName() {
            return this.$store.getters.selProjectInfo.projectName;
        },
        projectGroup() {
            let newprojectGroup = this.$store.state.project.projectGroup.filter(e => { if (e.firmId != this.$store.getters.selProjectInfo.firmId) return e })
            let list = []
            this.$store.state.project.projectGroup.forEach(item => {
                if (item.projectList) {
                    item.projectList.forEach(elm => {
                        list.push(elm)
                    })
                }
            })
            list = list.filter(e => { if (e.projectId != this.$store.getters.projectId) return e })
            // console.log(list, "list")
            return list
        },
        EnterpriseInfo() {
            return this.$store.state.project.EnterpriseInfo
        },
        routeName() {
            return this.$route.params.name;
        },
        projectInfo() {
            return this.$store.state.project.projectInfo
        },
        AreaId() {
            return this.$store.getters.areaId
        },
        projectId() {
            return this.$store.getters.projectId
        },
        WeatherInfo() {
            return this.$store.state.project.WeatherInfo
        },
        Ebox() {
            this.All = []
            if (this.gatewayall.length > 0) {
                this.gatewayall.map(item => {
                    let code = JSON.parse(item.device_details)
                    if(code.设备){
                        this.All.push(code.设备.code)
                    }
                })
            }
            // console.log(this.$store.getters.eBoxInfo(),"this.$store.getters.eBoxInfo()")
            let a = this.$store.getters.eBoxInfo().filter(
                (item) => item.online && this.All.includes(item.deviceId)
            )
            return a.length
        },
        mqttval() {
            return this.$store.getters.mqttVal;
        },

    },
    mounted() {
        // this.getUserAllgroup()
        this.All = []
        this.getEventPage()
        this.gateway()
        this.getSensorData()
        document.addEventListener("click", this.closePopover);
    },
    watch: {
        "$store.getters.projectId"(n, o) {
            this.getEventPage()
            this.gateway()
            this.getSensorData()
        },
        AreaId(n, o) {
            this.getSensorData()
        },
        '$store.state.project.AlarmEvent'(n,o){
            if(n!=o){
                // this.getEventPage();
                this.eventList = n
            }
        }
    },
    methods: {
        closePopover(e) {
            let self = this;
            if ((self.$refs.area&& !self.$refs.area.contains(e.target)) && (self.$refs.charea && !self.$refs.charea.contains(e.target))) {
                if (self.showGroup) {
                    self.showGroup = false;
                }
            }
        },
        //传感器
        getSensorData() {
            GetSensor(this.AreaId).then(res => {
                if (res.data.data.loop) {
                    this.subLoopUrl = res.data.data.loop.subLoopUrl
                    subscribe([res.data.data.loop.subLoopUrl])
                } else {
                    this.subLoopUrl = ""
                }
            })
            let obj = {
                areaId:this.AreaId,
                typeId:3
            }
            sensorType(obj).then(res => {
                if (res.data.data.loop) {
                    this.smokeSubLoopUrl = res.data.data.loop.subLoopUrl
                    subscribe([res.data.data.loop.subLoopUrl])
                } else {
                    this.smokeSubLoopUrl = ""
                }
            })
        },
        getWeatherInfo() {
            let self = this
            let WeatherInfo = {}
            fetch('https://devapi.heweather.net/v7/weather/now?location=' + this.$store.state.project.projectInfo.projectCoordinate +
                '&key=aa0dc97c8180424b91a79c7a0fe136ef')
                .then(response => response.json())
                .then(json => {
                    WeatherInfo.text = json.now.text
                    WeatherInfo.temp = json.now.temp
                    WeatherInfo.humidity = json.now.humidity
                    self.$store.state.project.WeatherInfo.text = WeatherInfo.text
                    self.$store.state.project.WeatherInfo.temp = WeatherInfo.temp
                    self.$store.state.project.WeatherInfo.humidity = WeatherInfo.humidity
                })
            fetch('https://devapi.qweather.com/v7/air/now?location=' + this.$store.state.project.projectInfo.projectCoordinate +
                '&key=aa0dc97c8180424b91a79c7a0fe136ef')
                .then(response => response.json())
                .then(json => {
                    WeatherInfo.category = json.now.category;
                    self.$store.state.project.WeatherInfo.category = WeatherInfo.category
                    //  this.$store.commit("setWeatherInfo", WeatherInfo);
                })
            // fetch('https://api.qweather.com/v7/solar-radiation/24h?location=' + this.$store.state.project.projectInfo.projectCoordinate +
            //     '&key=aa0dc97c8180424b91a79c7a0fe136ef')
            // .then(response => response.json())
            // .then(json => {

            //     WeatherInfo.category = json.now.category;
            //     this.$store.commit("setWeatherInfo", WeatherInfo);
            // })
        },
        //切换项目
        tagpark(group) {
            //连接mqtt
            this.$store.commit('restMqtt') 
            disconnect();
            alarmConnect();
            connectMqtt();
            //网关
            //this.$store.dispatch("websocketConnect");

            let EnterpriseInfo = this.$store.state.project.projectGroup.filter(e => { if (e.firmId == group.firmId) return e })[0]
            this.$store.commit("setEnterpriseInfo", EnterpriseInfo);
            this.$store.commit("setProjectId", group.projectId);
            this.$store.commit("setProjectInfo", group);
            // this.$store.commit("setAreaInfo", group.projectList[0].areaList[0]);
            this.$store.commit("setAreaId", -1);
            // this.$store.commit("setAreaId", group.projectList[0].areaList[0].areaId);
            // location.reload()
            //清空最近使用
            this.$store.commit('setRecentlyUsed', [])
            this.$router.push("/Home/Overview/SubstationManagement");
            this.$store.dispatch("getSiteList");
            this.getWeatherInfo();
            this.showGroup = false
        },
        goAlarmUrl() {
            this.$router.push({
                path: `/Home/WorkBench/EventManagement`,
                query: {
                    type: this.eventList.incident_classification,
                },
            })
            this.$store.commit("setCurrWorkBench",'/Home/WorkBench/EventManagement')    
            //this.$router.push("/Home/Overview/EventManagement");
        },
        //网关
        gateway() {
            DeviceALL().then((res) => {
                let all = res.data.data.devices
                this.gatewayall = []
                this.gatewayall = all.filter((item) => {   
                    if (item.name == "边缘网关") {
                        return item;
                    }
                });
            });
        },
        async getEventPage() {
            let obj = {
                projectId: this.$store.getters.projectId,
                page: 1,
                size: 1000,
                incidentClassificationClass: "urgent,hiddenDanger",
                identTypeClass: "",
                start: "",
                end: "",
                solveFlag: 0
            }
            let result = await EventListPage(obj);
            let data = result.data.data.eventList
            if (data.records.length > 0) {
                this.eventList = data.records[0]
                this.alarmShow = false
            } else {
                this.eventList = []
                this.alarmShow = true
            }
        },
        //切换区域
        checkArea(item, info, group) {
            this.$store.commit("setAreaId", item.areaId);
            // this.$store.commit("setProjectId", item.projectId);
            this.$store.commit("setAreaInfo", item);
            // this.$store.commit("setEnterpriseInfo",group);
            // this.$store.commit("setProjectInfo",info);
            if (item.areaId == 33) { //鲁泰大楼跳转总览
                this.$router.push("/Home/Overview/SubstationManagement");
                return false
            }
            //更换项目信息
            //play.currentProjectInfo().then((res) => {
            //      this.$store.commit(
            //         "setProjectInfo",
            //         res.data.data.project
            //     );
            // })
            if (item.areaType == 1) {
                this.$router.push("/Home/PowerDistribution/index");
            } else if (item.areaType == 2) {
                this.$router.push("/Home/Photovoltaic/index");
            }
            this.showGroup = false
        },
        //async getUserAllgroup(){
        // let res = await userAllgroup()
        // if(res.data.code == 200){
        // this.projectGroup = res.data.data[0].projectList

        //for(let i in this.projectGroup){
        //  let areaId = this.projectGroup[Object.keys(this.projectGroup)[0]][0].areaList[0].areaId;
        // this.$store.commit("setAreaId", areaId);
        //}
        //  let areaId = this.projectGroup[0].areaList[0].areaId
        //   this.$store.commit("setAreaId", areaId);
        // }else{
        //     console.log(res.data.errMsg);
        //  }
        // },
        getDistanceSpecifiedTime(dateTime) {
            var EndTime = new Date(dateTime);
            var NowTime = new Date();
            var t = NowTime.getTime() - EndTime.getTime();
            var d = Math.floor(t / 1000 / 60 / 60 / 24);
            return d;
        },
    }
}
</script>

<style lang="less" scoped>
.group {
    position: absolute;
    background: #ffffff;
    z-index: 9999;
    top: 56rem;
    left: 0;
    width: 100%;
    .h(580);
    color: #333333;
    overflow: hidden;

    .title {
        height: 60rem;
        line-height: 60rem;
        background: rgba(13, 148, 255, 0.1);
        font-size: 20rem;
        font-weight: bold;
        padding: 0 20px;

        span {
            color: #ffffff;
            font-size: 16rem;
            font-weight: 400;
            display: inline-block;
            background: url("../../assets/img/group.png") no-repeat;
            width: 89px;
            height: 26px;
            line-height: 26px;
            padding-left: 8px;
            cursor: pointer;
            float: right;
            margin-top: 15rem;
        }
    }

    .list {
        height: 44rem;
        line-height: 44rem;
        font-size: 18rem;
        padding: 0 20px 0 20px;
        cursor: pointer;

        span {
            float: right;
            line-height: 40rem;

            // width: 125px;
            img {
                vertical-align: middle;
                //height: 26px;
                //margin-right: 5px;
            }

            color: #0D94FF;
        }
    }

    .taglist .title {
        background: #f5f5f5;
    }

    .active {
        background: #0D94FF;
        color: #ffffff
    }
}
.workselist{
    .h(920)
}
.red {
    background: #FD4238 !important;

    .name {
        color: #ffffff !important;
    }

    // .right span {
    //     color: #ffffff !important;
    // }
}

.yell {
    background: #F6BD16 !important;

    .name {
        color: #ffffff !important;
    }

    // .right span {
    //     color: #ffffff !important;
    // }
}

.alarm {
    justify-content: space-between;
    font-size: 16rem;
    border-bottom: 1px solid rgba(238, 201, 199, 0.8);
    height: 45rem;
    padding: 0 20rem;
    width: 100%;

    img {
        width: 30rem;
        height: 30rem;
    }

    .left {
        justify-content: flex-start;
        cursor: pointer;
        .w(380);
    }

    .state {
        padding: 0 10rem;
        border-right: 2px solid #ffffff;
        height: 16rem;
        line-height: 18rem;
    }

    .name {
        font-size: 20rem;
        font-weight: bold;
        padding: 0 0 0 10rem;
        max-width: 70%;
        display: inline-block;
    }

    i {
        // font-weight: 600;
        font-size: 26rem;
    }
}

.projectInfo {
    background: #269A99;
    border-radius: 8rem;
    color: #fff;
    padding: 15rem 0 0 0;
    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    position: relative;
    .h(124);

    .top {
        overflow: hidden;
        padding: 0 20rem;
        width: 100%;

        .left {
            float: left;
            width: 80%;

            .name {
                width: 100%;
                text-overflow: ellipsis;
                white-space: nowrap;
                overflow: hidden;
            }
        }

        .right {
            float: right;
            font-size: 16rem;

            span {
                color: #ffffff;
                font-size: 24rem;
            }
        }

        .name {
            font-size: 24rem;
            font-weight: bold;
            color: #FFE88B;

            // margin-bottom: 5rem;
            img {
                cursor: pointer;
                margin-left: 10px;
            }

            span {
                font-size: 18rem;
            }
        }
    }

    .run {
        font-size: 18rem;
        font-weight: bold;
        padding: 0 20rem;
        width: 100%;

        span {
            font-size: 24rem;
        }
    }

    .weather {
        justify-content: space-between;
        font-size: 16rem;
        line-height: 33rem;
        padding: 0 20rem;
        width: 100%;

        span {
            display: inline-block;
        }
    }
}
</style>